var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84959 6.79262L7.49909 11.3993C7.49909 11.3993 7.49909 11.3993 7.49909 11.3993C7.61795 11.5171 7.61775 11.7051 7.49857 11.8227L6.81431 12.4974C6.69174 12.6183 6.4907 12.6183 6.36818 12.4975L6.36817 12.4974L0.501438 6.71192L0.501422 6.71191C0.38208 6.59423 0.382053 6.40581 0.501407 6.28808C0.501412 6.28807 0.501418 6.28807 0.501423 6.28806L6.36816 0.502556L6.13952 0.270699L6.36816 0.502555C6.49074 0.381677 6.69177 0.381699 6.8143 0.50254L6.81431 0.502555L7.49857 1.17734C7.61775 1.29487 7.61795 1.48291 7.49909 1.60068L2.84959 6.20741L2.55427 6.50002L2.84959 6.79262Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.823806
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.88e89913cd85730262f37cb71be19e81.svg";
export { ForwardRef as ReactComponent };